export default "__VITE_ASSET__9UmfO3qQ__"